<template>
  <div class="wrap">
    <div class="banner">
      <img src="@/assets/other/product-center.jpg" style="width: 100%" alt="" />
    </div>
    <Nav title="产品中心" />
    <div class="pagew content">
    <div class="type" v-for="(category, index) in categorizedProducts" :key="index">
      <div class="title">
        <span class="line"></span>
        {{ category.title }}
      </div>
      <div class="bottom-info">
        <div class="item" v-for="(product, pIndex) in category.products" :key="pIndex">
          <img :src="getProductImageUrl(product.productImg)" alt="" />
          <div class="txt">
            <span v-html="formatRemark(product.remark)"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
    <Footer :show="false" />
  </div>
</template>

<script>
import { getWorkList, getWorkYearList, getProductListAll } from '@/api/api.js';
import Nav from '../../components/Nav/Nav.vue';
export default {
  name: 'index',
  components: { Nav },
  data () {
    return {
      jsonData: [],
      categorizedProducts: [],
      imgList: [],
      url: '/Work',
      pageSize: 100,
      currentPage: 1,
      total: 0,
      activeIndex: '1',
      paramsYear: {
        workCompetition: this.$route.query.key
      }
    };
  },
  created () {
    // this.getList();
    this.getWorkYearList(this.paramsYear);
    this.getProductListAll();
  },
  methods: {
    getProductListAll () {
      getProductListAll({ state: 'Y' }).then(res => {
        this.jsonData = res.data.rows || [];
        this.categorizeProducts();
        console.log(res);
      });
    },
    categorizeProducts () {
      // 按title分类产品
      const categories = {};
      this.jsonData.forEach(product => {
        if (!categories[product.title]) {
          categories[product.title] = {
            title: product.title,
            products: []
          };
        }
        categories[product.title].products.push(product);
      });
      this.categorizedProducts = Object.values(categories);
    },
    getProductImageUrl (imagePath) {
      // 根据接口获取完整图片URL
      if (imagePath) {
        return `https://xulumaterial.com/prod-api/common/download/resource?resource=${imagePath}`;
      }
      return '';
    },
    formatRemark (remark) {
      // 将\n转换为<br>标签以实现换行显示
      if (!remark) return '';
      return remark.replace(/\n/g, '<br>');
    },
    getList () {
      getWorkList({}).then(res => {
        // this.imgList = res.data || [];
        console.log(res);
      });
    },
    getWorkYearList (paramsYear) {
      getWorkYearList(paramsYear).then(res => {
        this.imgList = res.data.rows || [];

        console.log(res);
      });
    },
    handleSelect (index) {
      console.log(index);
      this.getList();
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.getList();
    },
    toPage (item, index) {
      this.$router.push({
        path: 'Work/wordDetail',
        query: {
          id: index,
          title: item.workTitle,
          info: item
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.banner {
  margin-top: 82px;
}
.content {
  margin-top: 20px;
  .type {
    margin-top: 50px;
    .title {
      position: relative;
      width: 200px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      background-color: #5197d5;
      color: #fff;
      .line {
        display: inline-block;
        position: absolute;
        top: 22px;
        left: 20px;
        width: 15px;
        height: 3px;
        background-color: #fff;
      }
    }

    .bottom-info {
      display: flex;
      flex-wrap: wrap;
      justify-content: stretch;
      .item {
        height: 350px;
        border: 2px solid #5197d5;
        margin-top: 20px;
        margin-right: 50px;
        img {
          width: 250px;
          height: 200px;
          margin: 0 30px;
        }

        .txt {
          width: 310px;
          height: 100px;
          margin-top: 50px;
          padding: 10px 15px;
          line-height: 24px;
          font-size: 16px;
          text-align: center;
          background-color: #5197d5;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          overflow-y: auto;
          flex-wrap: wrap;

          span {
            display: block;
            width: 100%;
          }
        }
      }
    }
  }
}
.select {
  height: 80px;
  width: 60%;
  margin: 0 auto;
}
.el-menu-item.is-active {
  border-bottom: 2px solid red !important;
  color: red !important;
  font-weight: bold;
}

.el-menu-item {
  padding: 0 43px;
}
.page {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.img-title {
  text-align: center;
}

.wrap {
  text-align: left;
  width: 100%;

  .banner {
    width: 100%;
    z-index: -2;
  }

  .imgbox {
    .box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .boxitem {
        width: 25%;
        padding-bottom: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .onde {
          width: 90%;
          height: 320px;

          .top {
            position: relative;

            .ditu {
              width: 100%;
              height: 45px;
              line-height: 45px;
              text-align: center;
              top: 175px;
              color: #ffffff;
              font-size: 14px;
              position: absolute;
              background: url("../../assets/workimg/ditu.png") no-repeat;
              background-position: center;
            }
          }

          .cont {
            font-size: 14px;
            text-align: center;
            background-color: #f5f5f5;
            padding: 20px 0;
          }

          .bottom {
            width: 100%;
            background-color: #f5f5f5;
            padding: 10px 0;
            display: flex;
            font-size: 14px;
            justify-content: space-around;
            align-items: center;

            div {
              // width: 50%;
              text-align: right;
              // padding-right: 10px;
            }
          }
        }
      }

      .boxitem:hover {
        border-bottom: 1px solid red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Work/list3.vue